// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4mr1r","textarea":"styles_textarea__R8qNu"};